// Simple "in" mark drawn for this site. lucide-react has no brand icons.
const LinkedInIcon = ({ className = "" }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" className={className}>
    <circle cx="5.25" cy="5.25" r="2.25" />
    <rect x="3.25" y="9" width="4" height="12" rx="0.5" />
    <path d="M10 9h3.8v1.7c.55-1 1.9-2 3.9-2 4 0 4.8 2.6 4.8 6V21h-4v-5.6c0-1.4-.03-3.1-1.9-3.1-1.9 0-2.2 1.5-2.2 3V21H10z" />
  </svg>
);

export const LINKEDIN_URL = "https://www.linkedin.com/in/afisch/";
export const LINKEDIN_HANDLE = "linkedin.com/in/afisch";

export default LinkedInIcon;
